<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {reactive, computed, ref, onMounted} from "vue";
import { useUserStore } from "../../../store/users"
import { useModalStore } from "../../../store/modal"

const icon = computed(() => !user_updated.value ? 'user-single' : 'check-single')
const heading = computed(() => !user_updated.value ? 'Edit user.' : `Changes saved.`)
const error = ref(null)
const loading = ref(false)
const user_updated = ref(false)
const userStore = useUserStore()
const modalStore = useModalStore()
const options = userStore.roles
const user = reactive({
    role: null,
    first_name: null,
    last_name: null,
    email: null,
    contact_number: null,
})

const disabled = computed(() => {
  return Object.values(user).some(value => value === null || value === "");
});
const updateUser = async () => {
    error.value = null
    loading.value = true
    try {
        await userStore.updateUser(userStore.user.id, user)
        user_updated.value = true
    }
    catch (err) {
        error.value = err.response.data.message ?? "Something went wrong. Please try again."
    } finally {
        loading.value = false
    }
}

onMounted(async () => {
    loading.value = true
    await userStore.getUser(modalStore.props.id)
    loading.value = false
    user.role = userStore.user?.roles[0]?.name
    user.first_name = userStore.user?.first_name
    user.last_name = userStore.user?.last_name
    user.email = userStore.user?.email
    user.contact_number = userStore.user?.contact_number
})
</script>

<template>
    <default-modal-base :heading :icon :loading :refresh="user_updated" :error>
        <div class="user-add-modal-container" v-if="!user_updated">
            <brand-form-select label="Role." :options v-model="user.role" />
            <brand-form-input label="First Name." v-model="user.first_name" />
            <brand-form-input label="Last Name." v-model="user.last_name" />
            <brand-form-input label="Email." v-model="user.email" type="email"/>
            <brand-form-input label="Cellphone." v-model="user.contact_number" type="tel"/>
            <brand-button :disabled @click.prevent="updateUser()">Save changes</brand-button>
        </div>

        <brand-button variant="secondary" v-else @click.prevent="modalStore.close(true)">Done</brand-button>
    </default-modal-base>
</template>

<style scoped lang="scss">
.user-add-modal-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .brand-button {
        margin-top: 2rem;
    }
}

.brand-button {
    width: 100%;
}
</style>
